import "@fontsource/fraunces/400.css";
import "@fontsource/fraunces/600.css";
import "@fontsource/fraunces/700.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";
import "../stylesheets/tokens.css";

import React from "react";
import { createRoot } from "react-dom/client";
import AppContainer from "./AppContainer";

export const startProject = () => {
  // Imported for its side effect; the actual mount happens below.
};

const renderFatal = (container: HTMLElement, err: unknown) => {
  const msg = err instanceof Error ? err.message : String(err);
  container.innerHTML = `
    <div style="font-family: 'Source Sans 3', sans-serif; padding: 2rem; max-width: 640px; margin: 2rem auto; background: #fffaf3; color: #1c1917; border-radius: 12px; border: 1px solid #dfd2c2;">
      <h2 style="margin: 0 0 1rem; font-family: Fraunces, Georgia, serif; color: #b42318;">Lightning Swap — frontend failed to render</h2>
      <pre style="white-space: pre-wrap; font-size: 13px; color: #6f655c;">${msg}</pre>
    </div>`;
};

const initApp = () => {
  const container = document.getElementById("root");
  if (!container) return;
  try {
    createRoot(container).render(<AppContainer />);
  } catch (err) {
    console.error(err);
    renderFatal(container, err);
  }
};

window.addEventListener("error", (e) => {
  const container = document.getElementById("root");
  if (container && !container.hasChildNodes()) renderFatal(container, e.error || e.message);
});

window.addEventListener("unhandledrejection", (e) => {
  console.error("unhandledrejection", e.reason);
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initApp);
} else {
  initApp();
}
